module.exports = __webpack_public_path__ + "assets/7fcdf575553d99f7f27d30b2068dd3c2.mp3";